import './AnimatedLogo.css';

const AnimatedLogo = ({ className = '' }) => {
  return (
    <div className={`animated-logo ${className}`}>
      <span className="logo-text">TÆKNI</span>
    </div>
  );
};

export default AnimatedLogo;